var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},_vm._l((_vm.radioNavList),function(item){return _c('el-radio',{key:item,attrs:{"label":item},model:{value:(_vm.radio),callback:function ($$v) {_vm.radio=$$v},expression:"radio"}},[_vm._v(_vm._s(item))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }